import { amplifyProxy, directApi } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    landlordsToPay: '',
    contractorsToPay: '',
    tenantsToPay: '',
    zeroBalance: '',
    loading: {
      landlords: false,
      contractors: false,
      tenants: false,
      zero: false,
      pause: false,
      download: false
    },
    error: {
      landlords: null,
      contractors: null,
      tenants: null,
      zero: null,
      pause: null,
      download: null
    }
  },
  mutations: {
    SET_LANDLORDS_PAYMENTS(state, data) {
      state.landlordsToPay = data
    },
    SET_TENANTS_PAYMENTS(state, data) {
      state.tenantsToPay = data
    },
    SET_CONTRACTORS_PAYMENTS(state, data) {
      state.contractorsToPay = data
    },
    SET_ZERO_BALANCE_PAYMENTS(state, data) {
      state.zeroBalance = data
    },
    SET_LOADING(state, { type, value }) {
      state.loading[type] = value
    },
    SET_ERROR(state, { type, error }) {
      state.error[type] = error
    }
  },
  getters: {
    getAllOutgoingPayments(state) {
      if (state.zeroBalance === '') {
        return null
      } else {
        let concatenated = [
          state.landlordsToPay,
          state.contractorsToPay,
          state.tenantsToPay,
          state.zeroBalance
        ]

        let set = new Set()
        let unionArray = concatenated.flat().filter(item => {
          if (!set.has(item.PayeeID) && item.PayeeID !== "") {
            set.add(item.PayeeID)
            return true
          }
          return false
        }, set)

        var filtered = unionArray.filter(el => el !== "")

        return filtered
      }
    }
  },
  actions: {
    async pausePayment({ commit, rootState }, payload) {
      commit('SET_LOADING', { type: 'pause', value: true })
      commit('SET_ERROR', { type: 'pause', error: null })

      try {
        const response = await amplifyProxy.post(`/${rootState.user.ClientName}/outgoingPayments/togglePause`, {}, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            personID: payload
          }
        })
        return response
      } catch (error) {
        commit('SET_ERROR', { type: 'pause', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'pause', value: false })
      }
    },

    async downloadInvoice({ commit, rootState }, payload) {
      commit('SET_LOADING', { type: 'download', value: true })
      commit('SET_ERROR', { type: 'download', error: null })

      try {
        await directApi.downloadInvoice(
          rootState.user.ClientName,
          payload.invoiceID,
          payload.filename,
          rootState.user.LoginToken
        )
        // directApi handles the complete download, including cleanup
        return { success: true }
      } catch (error) {
        commit('SET_ERROR', { type: 'download', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'download', value: false })
      }
    },

    async getLandlordsPayments({ commit, rootState }) {
      commit('SET_LOADING', { type: 'landlords', value: true })
      commit('SET_ERROR', { type: 'landlords', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/outgoingPayments/landlords/records`, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        commit('SET_LANDLORDS_PAYMENTS', response.data.ToPay)
        return response.data.ToPay
      } catch (error) {
        commit('SET_ERROR', { type: 'landlords', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'landlords', value: false })
      }
    },

    async getTenantsPayments({ commit, rootState }) {
      commit('SET_LOADING', { type: 'tenants', value: true })
      commit('SET_ERROR', { type: 'tenants', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/outgoingpayments/tenants/records`, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        commit('SET_TENANTS_PAYMENTS', response.data.ToPay)
        return response.data.ToPay
      } catch (error) {
        commit('SET_ERROR', { type: 'tenants', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'tenants', value: false })
      }
    },

    async getContractorsPayments({ commit, rootState }) {
      commit('SET_LOADING', { type: 'contractors', value: true })
      commit('SET_ERROR', { type: 'contractors', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/outgoingpayments/contractors/records`, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        commit('SET_CONTRACTORS_PAYMENTS', response.data.ToPay)
        return response.data.ToPay
      } catch (error) {
        commit('SET_ERROR', { type: 'contractors', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'contractors', value: false })
      }
    },

    async getZeroBalancePayments({ commit, rootState }) {
      commit('SET_LOADING', { type: 'zero', value: true })
      commit('SET_ERROR', { type: 'zero', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/outgoingpayments/all/records`, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        commit('SET_ZERO_BALANCE_PAYMENTS', response.data.ToPay)
        return response.data.ToPay
      } catch (error) {
        commit('SET_ERROR', { type: 'zero', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'zero', value: false })
      }
    }
  }
}